import { render, staticRenderFns } from "./greennEnvios.vue?vue&type=template&id=90053470&scoped=true"
import script from "./greennEnvios.vue?vue&type=script&lang=js"
export * from "./greennEnvios.vue?vue&type=script&lang=js"
import style0 from "./greennEnvios.vue?vue&type=style&index=0&id=90053470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90053470",
  null
  
)

export default component.exports